import { Mail } from "lucide-react";
import { BUSINESS } from "../../lib/site-content";

export default function FloatingActions() {
  return (
    <div className="md:hidden fixed bottom-5 inset-x-5 z-40 flex gap-3">
      <a
        href={BUSINESS.emailHref}
        className="flex-1 inline-flex items-center justify-center gap-2 h-14 bg-stone-900 text-white text-sm tracking-wider shadow-xl shadow-stone-900/20"
      >
        <Mail className="w-4 h-4" />
        Email Us
      </a>
    </div>
  );
}
